<div class="table-responsive shadow rounded">
    <table class="table table-hover table-striped m-0">
        <thead>
            <tr>
                <th>{{ "helpdesk.section" | translate }}</th>
                @for (year of years(); track year) {
                    <th class="text-center">{{ year }}</th>
                }
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="select-all">{{ "common.form.label.select_all" | translate }}</td>
                @for (year of years(); track year) {
                    <td class="select-all text-center">
                        <input
                            class="form-check-input checkbox"
                            type="checkbox"
                            [checked]="isSelectAllChecked(year)"
                            (change)="selectAll($event, year)"
                        />
                    </td>
                }
            </tr>
            @for (section of sections(); track section) {
                <tr>
                    <td>{{ section | translateToken: "sectionName" }}</td>
                    @for (year of section.years; track year) {
                        <td class="text-center">
                            <input
                                class="form-check-input checkbox"
                                type="checkbox"
                                [checked]="year.isVisible"
                                (change)="ruleValueChanged($event, year)"
                            />
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
</div>

<div class="my-2">
    <adaa-form-action-buttons saveButtonTitle="common.form.button.submit" (saveClicked)="submit()" (cancelClicked)="goBack()" />
</div>
